import React from 'react';

const attachmentField = props => {
  const data = props.formData || {};
  return (
    <div>
      <input type="text" name="extension" value={data.extension} data-cy="extension" />
      <input type="text" name="original_name" value={data.original_name} data-cy="original_name" />
      <input type="text" name="remote_name" value={data.remote_name} data-cy="remote_name" />
    </div>
  );
};

export default attachmentField;
